import { render, staticRenderFns } from "./ChooseTopicToPrintDialog.vue?vue&type=template&id=3b604de3&scoped=true"
import script from "./ChooseTopicToPrintDialog.vue?vue&type=script&lang=js"
export * from "./ChooseTopicToPrintDialog.vue?vue&type=script&lang=js"
import style0 from "./ChooseTopicToPrintDialog.vue?vue&type=style&index=0&id=3b604de3&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b604de3",
  null
  
)

export default component.exports